import { makeRequired } from 'CorePackage/MainModule/validators/isRequired';
import { composeValidators } from 'CorePackage/MainModule/validators/composeValidators';
import { makeMaxCharactersValidator } from 'CorePackage/MainModule/validators/maxCharacters';
import { REQUIRED_ERROR } from 'CorePackage/MainModule/constants/validationErrors';
import { store } from 'CorePackage/MainModule/common/store';
import { getUserRoleIsProsecutorOrSuperProsecutor } from 'AuthPackage/MainModule/selectors/authSelectors';
import { AgreementStatusEnum } from 'APIPackage/KnmModule/enums/AgreementStatusEnum';

import { IErknmFormAgreementApprove } from '../interfaces/IErknmFormAgreementApprove';

export const getAgreementApproveInfoValidate = (
  approveInfo: IErknmFormAgreementApprove | undefined,
  status: AgreementStatusEnum | undefined,
) => {
  const state = store.getState();
  const isProsecutorOrSuperProsecutor = getUserRoleIsProsecutorOrSuperProsecutor(state);

  if (!approveInfo || !isProsecutorOrSuperProsecutor) {
    return undefined;
  }

  if (status !== AgreementStatusEnum.ON_APPROVAL) {
    return undefined;
  }

  return {
    note: makeMaxCharactersValidator(4096, 'Превышена допустимая длина строки')(approveInfo.note || ''),
    approved: composeValidators(makeRequired(REQUIRED_ERROR), () =>
      approveInfo.approved?.value === 'ON_APPROVAL' ? REQUIRED_ERROR : undefined,
    )(approveInfo.approved),
    numberDecision: makeRequired(REQUIRED_ERROR)(approveInfo.numberDecision),
    dateDecision: makeRequired(REQUIRED_ERROR)(approveInfo.dateDecision),
    whoMadeDecision: makeRequired(REQUIRED_ERROR)(approveInfo.whoMadeDecision),
    titleSigner: makeRequired(REQUIRED_ERROR)(approveInfo.titleSigner),
    attachment: makeRequired(REQUIRED_ERROR)(approveInfo.attachment),
  };
};
